import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState } from '../../../../../../../../types/types';
import { SegmentCardEvent, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { COLOR_TAGS_SEARCH_SCROLL_TIMEOUT } from '../../components/constants';
import {
    getColorTagsSessionRecordingNeeded
} from '../../../../../../../../helper/sessionRecorderHelper/selectors/getColorTagsSessionRecordingNeeded';
import { root } from '../../../../../../../../store/constants';
import {
    getBoardKNBCardColorTagsSearchUsed
} from '../../../../../../../../store/model/board/selectors/getBoardKNBCardColorTagsSearchUsed';
import { getActiveBoardId } from '../../../../../../../../store/model/selectors/getActiveBoardId';
import {
    getBoardColorTagsSearchScrolled
} from '../../../../../../../../store/model/board/selectors/getBoardColorTagsSearchScrolled';
import {
    boardSetColorTagsSearchScrolled
} from '../../../../../../../../rest/effects/board/boardSetColorTagsSearchScrolled';

export const onOpen = (
    colorTagsCount: number,
): ThunkAction => {
    return (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        if (getColorTagsSessionRecordingNeeded(colorTagsCount)) {
            root.App.controller.mainView.sessionRecorder.startRecording();
        }
        dispatch(segmentTrackAction(SegmentCardEvent.CARD_COLOR_TAGS_CLICKED));
        const state = getState();
        const boardId = getActiveBoardId(state);
        if (!getBoardColorTagsSearchScrolled(state, boardId) && getBoardKNBCardColorTagsSearchUsed(state, boardId)) {
            setTimeout(() => {
                dispatch(boardSetColorTagsSearchScrolled(boardId, true));
            }, COLOR_TAGS_SEARCH_SCROLL_TIMEOUT + 200);
        }
    }
}
